import { render, staticRenderFns } from "./AS_QrtlyAccountStatementLegacy.vue?vue&type=template&id=1005d6a5&scoped=true&"
import script from "./AS_QrtlyAccountStatementLegacy.vue?vue&type=script&lang=js&"
export * from "./AS_QrtlyAccountStatementLegacy.vue?vue&type=script&lang=js&"
import style0 from "./AS_QrtlyAccountStatementLegacy.vue?vue&type=style&index=0&id=1005d6a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005d6a5",
  null
  
)

export default component.exports